import { getPrimaryConfig, isDevLikeEnv } from "@crystal/config";
import { evaluateConfig, isBrowser } from "@crystal/core";
import { getGlobalThis } from "@crystal/core/utils";
import { createHttp } from "@crystal/http";
import * as dm from "deepmerge";
import { glassConfig } from "./configs.js";
const { all: deepmerge } = { ...dm }.default || dm;
const createGlassHttp = ({ proxy = true, local = false, clientTag = "" } = {}, requestOptions = {}) => {
  const { sitePath, brand, locale, env } = evaluateConfig(getPrimaryConfig());
  const { apiServer, originalHost } = evaluateConfig(glassConfig);
  let server = apiServer;
  if (env === "local" && !local) {
    const { apiServer: apiServer2 } = glassConfig.evaluateWithContext({ brand, locale, env: "dev" });
    server = apiServer2;
  }
  const glassHeaders = {
    ...isOriginalHostRequired(env) && { "x-original-host": originalHost }
  };
  const headers = {
    ...getOverrideHeaders(),
    ...glassHeaders,
    ...clientTag && { "X-CLIENT-TAG": clientTag }
  };
  const query = {
    ...sitePath && { sitePath }
  };
  const glassOptions = {
    headers,
    query
  };
  const proxyServer = isBrowser() ? location.origin : server;
  const config = {
    apiServer: proxy ? proxyServer : server
  };
  return createHttp(config, deepmerge([glassOptions, requestOptions]));
};
function getOverrideHeaders() {
  const { env } = evaluateConfig(getPrimaryConfig());
  const win = getGlobalThis();
  let overrideHeaders = null;
  if (win.sessionStorage) {
    overrideHeaders = win.sessionStorage.getItem("glassHeaderOverrides");
  }
  if (!overrideHeaders)
    return {};
  try {
    return JSON.parse(overrideHeaders);
  } catch (e) {
    if (isDevLikeEnv(env)) {
      console.warn("Could not parse override-headers", overrideHeaders);
    }
  }
  return {};
}
function isOriginalHostRequired(env) {
  if (env === "local" || !isBrowser())
    return true;
  return location.origin.endsWith("3stripes.net");
}
export {
  createGlassHttp,
  getOverrideHeaders
};
//# sourceMappingURL=http.js.map
